<template>
  <div class="content">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "Content",
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.content {
    padding: 24px 0 0;
    border-bottom: 1px solid #e0e0e0;
    &:last-child{
      border-bottom: none;
    }

}
</style>